import React, { memo } from 'react';
import { Button, Modal } from 'react-bootstrap';

import { DateTimeService } from 'src/services/DateTimeService';

import { OPERATION_PROPS } from '../../constants';
import { ILoyaltyBonusOperation } from '../../interfaces';

import styles from './styles.module.scss';

export const OperationInfoModal = memo<{
  data?: null | ILoyaltyBonusOperation;
  onHide(): void;
}>(({ data, onHide }) => {
  const { type, typeText, createdAt, reasonText, amount } = data || {};

  if (type == null) return null;

  const { amountLabel, digit } = OPERATION_PROPS[type] || {};

  return (
    <Modal className="modal-slide" show={!!data} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title as="h5">{typeText}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mt-2">
          <dl className={styles.dList}>
            <dt>Дата</dt>
            <dd>{createdAt && DateTimeService.format(createdAt)}</dd>

            <dt>Причина</dt>
            <dd>{reasonText}</dd>

            <dt>{amountLabel}</dt>
            <dd>
              {digit}
              {amount}
            </dd>
          </dl>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

OperationInfoModal.displayName = 'OperationInfoModal';
